const dataStatusAR = [
  {value: 1,label: "เร่งรัดส่งหา CEO",},
  {value: 2,label: "CEO ตีกลับ หาเร่งรัด",},
  // {value: 3, label: "CEO ส่งหา การตลาด",},
  {value: 3, label: "การตลาด",},
  // {value: 4,label: "CEO ส่งหา กฎหมาย/ภาคสนาม",},
  {value: 4,label: "ทนาย/ภาคสนาม",},
  // {value: 5, label: "กฎหมาย ตีเคสกลับหาเร่งรัด (ออโต้)",},
  {value: 5, label: "ยกเลิกเคส(ออโต้)",},
  // {value: 6,label: "กฎหมายส่ง ทนาย/ภาคสนาม",},
];
export default dataStatusAR;
